module.exports = __webpack_public_path__ + "static/img/cow_w_milk.515836fd.png";